import React from "react";
import BaseCard from "./BaseCard";
import correct from "../.././../assets/images/redcorrect.png";

const EnterpriseCard = ({ isAnnual }) => (
  <BaseCard
    tier="Enterprise"
    monthlyPrice="Custom"
    annualPrice="Custom"
    period="Monthly"
    buttonText="Talk to us"
    features={[
      "Customised minutes and features packages",
      "Omni-modality",
      "700+ song templates",
      "Early feature access",
      "Premium support",
      "All usage options",
    ]}
    isAnnual={isAnnual}
    cardStyle={{
      border: "1px solid var(--Color-Light-Opacity-White-10, #FFFFFF1A)",
    }}
    path={correct}
  />
);

export default EnterpriseCard;
